module.exports = __webpack_public_path__ + "static/liara-portyr-mtg_clb-fe0e3ee5789c62079e7291ac8b1452e6.webp";